import './BookingAppointmentCss/DoctorInfoCard.css';
import defaultImg from '../../Assets/defaultImg.png';
import { FaMapMarkerAlt, FaRupeeSign, FaHospital } from 'react-icons/fa';
import { FaStethoscope } from "react-icons/fa6";
import { useParams } from 'react-router-dom';
import doctorDefault from "../../Assets/doctor_default_copy.jpeg";
import { FaIdBadge } from "react-icons/fa";


export default function DoctorInfoCard({ doctor,onCenterChange,selectedCenter,selectedTime }) {
    console.log("doctor in doc card >>", selectedCenter);
    

    const {step} = useParams();
    if (!doctor) return null;

    return (
        <div className="appointment-doctor-info-card">
            <div className="appointment-doctor-profile">
                {doctor.DoctorPictureUrl ? (
                    <img
                        src={doctor.DoctorPictureUrl}
                        alt={doctor.doctor_name}
                        className="appointment-doctor-image"
                    />
                ) : (
                    <img
                        src={doctorDefault}
                        alt={doctor.doctor_name}
                        className="appointment-doctor-image"
                    />
                )}
                <div>
                    <h2 className="appointment-doctor-name" >Dr. {doctor.doctor_name}</h2>
                    <div className="specialty" style={{fontSize:"15px",marginTop: "0.3rem"}}>
                        {/* {doctor.specialization.length > 20
                            ? `${doctor.specialty.slice(0, 20)}...`
                            : doctor.specialty} */}
                          <span><FaStethoscope size={17} style={{ color: "rgb(24, 79, 123)" }} /> {doctor?.specialization}</span>
                    </div>

                   

                    <div className="location" style={{ marginTop: "0.3rem", fontSize:"15px" }}>
  <FaIdBadge size={16} style={{ color: "#6a1b9a", marginRight: 6 }} />
  {doctor?.Designation}
</div>
                     <div className="location" style={{ marginTop: "0.3rem",fontSize:"15px" }}>
                        <FaMapMarkerAlt size={17}/> {doctor?.centers?.map(center => center.center_name).join(", ")}
                    </div>
                </div>
            </div>

            {/* <div>
                <h3 style={{margin:"0", marginTop:"1rem"}}>Choose Preferable Center</h3>
            <div className="center-tabs">
          {doctor.centers.map((center) => (
            <button
              disabled={step != "date-and-time"}
              key={center.center_id}
              className={`center-tab ${selectedCenter?.center_id === center.center_id ? "active" : ""} ${step != "date-and-time" ? "disabled" : ""}`}
              onClick={() => onCenterChange(center)}
            >
              {center.center_name}
            </button>
          ))}
        </div>

            </div> */}

            {/* <div className="step1-Heading">
                <h3 style={{margin:"0", marginTop:"1rem"}}>Booking Info.</h3>
            </div> */}
            {doctor.centers.length > 1 ? (
                 <div>
                <h3 style={{margin:"0", marginTop:"1rem"}}>Choose Preferable Center</h3>
            <div className="center-tabs">
          {doctor.centers.map((center) => (
            <button
              disabled={step != "date-and-time"}
              key={center.center_id}
              className={`center-tab ${selectedCenter?.center_id === center.center_id ? "active" : ""} ${step != "date-and-time" ? "disabled" : ""}`}
              onClick={() => onCenterChange(center)}
            >
              {center.center_name}
            </button>
          ))}
        </div>

            </div>
            ): null}
           
            <div className="step1-booking-info">
                <div className="step1-booking-info">
                    <div className="step1-info-block">
                        <p className="step1-info-label">Center</p>
                        <p className="step1-info-value"><FaHospital size={14} style={{ marginRight: 8, color: '#1775a3' }} />{selectedCenter?.center_name}</p>
                    </div>

                    <div className="step1-divider" />

                    <div className="step1-info-block">
                        <p className="step1-info-label">Location</p>
                        <p className="step1-info-value"><FaMapMarkerAlt size={14} style={{ marginRight: 8, color: '#e53935' }} />{selectedCenter?.center_Address}</p>
                    </div>

                    <div className="step1-divider" />

                    <div className="step1-info-block">
                        <p className="step1-info-label">Fees</p>
                        <p className="step1-info-value"><FaRupeeSign size={14} style={{ marginRight: 8, color: '#1b5e20' }} />{selectedCenter?.Fees}/-</p>
                    </div>
                </div>
                {/* <div>
                    <p className="step1-info-label">Center</p>
                    <p className="step1-info-value">{selectedCenter?.center_name}</p>
                </div> */}
                {/* <div>
                    <p className="step1-info-label">Appointment Time</p>
                    <p className="step1-info-value">{selectedTime}</p>
                </div>
                <div>
                    <p className="step1-info-label">Appointment Type</p>
                    <p className="step1-info-value">OPD</p>
                </div> */}
            </div>
           
        </div>
    );
}
